import { aggregateDisplayOptions, fieldNames } from './fields';

const defaultState = {
    displayOptions: aggregateDisplayOptions,
    fields: fieldNames,
    nonReportingFields: [fieldNames.divider, fieldNames.title, fieldNames.richContent, fieldNames.pageBreak]
};

const formFields = (state = defaultState, action) => state;

export default formFields;
